<template>
  <div class="ability-user">
    <div class="ability-banner-wrapper">
      <div class="ability-banner-area w1200">
        <h1>用户运营</h1>
        <p>帮助商家完成用户触达管理及沉淀私域流量需求，构建用户运营闭环</p>
        <a href="/">立即创建体验</a>
      </div>
    </div>
    <div class="usermanage-ct-ex-bg">
      <div class="usermanage-ct-ex w1200">
        <div class="ct-title">用户运营的痛点</div>
        <div class="ct-ex-content">
          <div class="content-item">
            <img :src="require('@/assets/images/ability33.png')" />
            <div class="item-title">沟通路径难统一</div>
            <div class="item-content">
              客户沟通工具越来越多样化，触达受到的限制也越来越多，用户管理出现断层，效率下滑
            </div>
          </div>
          <div class="content-item">
            <img :src="require('@/assets/images/ability34.png')" />
            <div class="item-title">用户画像不清晰</div>
            <div class="item-content">
              缺乏科学的用户生命周期管理体系，难以区别不同阶段的用户画像，运营效率低下
            </div>
          </div>
          <div class="content-item">
            <img :src="require('@/assets/images/ability35.png')" />
            <div class="item-title">难以沉淀高忠诚用户</div>
            <div class="item-content">
              无法对用户进行阶梯分层，进而无法针对特定用户进行特定运营，难以沉淀出高忠诚用户
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="usermanage-ct-loop-bg">
      <div class="usermanage-ct-loop w1200">
        <div class="ct-title">从公域流量到私域流量，沉淀高忠诚用户群体</div>
        <img :src="require('@/assets/images/ability36.png')" />
      </div>
    </div>
    <div class="usermanage-ct-white-bg">
      <div class="usermanage-ct-white w1200">
        <div class="text">
          <div class="ct-title">高效的群工具沟通触达</div>
          <div class="text-content">
            <div class="">
              群工具：多种沟通触达方式，结合组织管理和SCRM能力，绑定自定义渠道标签，精准追踪流量来源和渠道投放的性价比
            </div>
          </div>
        </div>
        <img :src="require('@/assets/images/ability37.png')" />
      </div>
    </div>
    <div class="usermanage-ct-color-bg">
      <div class="usermanage-ct-color w1200 flex-row-reverse">
        <div class="text">
          <div class="ct-title">采集信息构建用户画像</div>
          <div class="text-content">
            <div>
              信息采集：从访问店铺一开始就精准捕捉意向用户的基本信息，配合后台强大的数据分析功能，可以实现对用户生命周期的全流程管理与促活
            </div>
          </div>
        </div>
        <img :src="require('@/assets/images/ability38.png')" />
      </div>
    </div>
    <div class="usermanage-ct-white-bg">
      <div class="usermanage-ct-white w1200">
        <div class="text">
          <div class="ct-title">标签分组实现针对性运营</div>
          <div class="text-content">
            <div class="">
              用户分群：根据用户画像及阶梯价值，对用户进行分群管理，实施差异化的运营计划
            </div>
            <div class="mg">
              运营计划：针对指定的用户人群在指定时间内，发放权益和通知，与运营计划的效果反馈相结合
            </div>
          </div>
        </div>
        <img :src="require('@/assets/images/ability39.png')" />
      </div>
    </div>
    <div class="usermanage-ct-color-bg">
      <div class="usermanage-ct-color w1200 flex-row-reverse">
        <div class="text">
          <div class="ct-title">超级会员沉淀高忠诚用户</div>
          <div class="text-content">
            <div>
              超级会员：配合群工具和信息采集功能的触达，引导用户购买店铺的超级会员身份，完成高忠诚用户绑定
            </div>
            <br />
            <div>
              会员运营：支持自定义会员规则，向特定人群开放专属权益；可设置正式会员与体验会员
            </div>
          </div>
        </div>
        <img :src="require('@/assets/images/ability40.png')" />
      </div>
    </div>
    <div>
      <div class="ability-block-advantage w1200">
        <p class="advantage-title">知链的优势</p>
        <div class="advantage-list">
          <div class="advantage-item">
            <img :src="require('@/assets/images/ability41.png')" alt="" />
            <h6>专注知识产品变现</h6>
            <p>多年专注深耕知识付费，更专业的内容服务变现系统</p>
          </div>
          <div class="advantage-item">
            <img :src="require('@/assets/images/ability42.png')" alt="" />
            <h6>自主品牌展示</h6>
            <p>打通社交流量渠道，构建自主品牌展示矩阵</p>
          </div>
          <div class="advantage-item">
            <img :src="require('@/assets/images/ability43.png')" alt="" />
            <h6>完整的经营闭环</h6>
            <p>从品牌营销-内容交付变现-用户管理的经营闭环</p>
          </div>
          <div class="advantage-item">
            <img :src="require('@/assets/images/ability44.png')" alt="" />
            <h6>数据化经营分析</h6>
            <p>涵盖获客、交易、商品等的全流程经营数据分析</p>
          </div>
        </div>
        <div v-if="$store.state.sceneClassName !== 'app'" class="ct-eva-title">
          客户评价
        </div>
        <div
          v-if="$store.state.sceneClassName !== 'app'"
          class="ct-eva-content"
        >
          <img :src="require('@/assets/images/ability45.png')" />
          <div class="eva-description">
            <div class="eva-desc-title">环球教育</div>
            <div class="eva-desc-content">
              我们的学员逐渐可以在一个系统的环境中自发学习，也能够体验到我们所提供非常完整的服务，这和知链平台的使用有很大的关系。它不仅是一个完善的知识付费系统，在使用过程中，还能帮助我们建立完备的学员管理系统，解决了曾经困扰我们很久的用户管理问题。
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-case-list></v-case-list>
    <div class="ct-eva-box" v-if="$store.state.sceneClassName === 'app'">
      <div class="ct-eva-title">客户评价</div>
      <div class="ct-eva-content">
        <img :src="require('@/assets/images/ability13.png')" />
        <div class="eva-description">
          <div class="eva-desc-title">21世纪经济报道</div>
          <div class="eva-desc-content">
            知链解决我们与内容的联动，通过知链内容市场能一键获取好课，大大节省了我们的时间成本。
          </div>
        </div>
      </div>
    </div>
    <v-free
      title="现在创建店铺，解决传播引流和成交转化难题"
      desc="专业客户经理解答指引 贴心解决您的问题"
      href=""
    ></v-free>
  </div>
</template>

<script>
import Free from '@/components/Free';
import CaseList from '@/components/CaseList';
export default {
  data() {
    return {
      isOpen: false
    };
  },
  components: {
    'v-free': Free,
    'v-case-list': CaseList
  },
  methods: {
    openSee() {
      this.isOpen = true;
    }
  }
};
</script>

<style lang="scss">
.ability-user {
  .ability-banner-wrapper {
    position: relative;
    padding-top: 218px;
    height: 640px;
    width: 100%;
    color: #fff;
    background-color: #1472ff;
    background-image: url('~@/assets/images/ability32.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto 640px;
  }
  .ability-banner-wrapper .ability-banner-area h1 {
    margin-bottom: 32px;
    font-size: 64px;
    line-height: 72px;
    font-weight: 600;
  }
  .ability-banner-wrapper .ability-banner-area p {
    margin-bottom: 72px;
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;
    width: 400px;
  }
  .ability-banner-wrapper .ability-banner-area a {
    display: block;
    width: 144px;
    height: 44px;
    line-height: 44px;
    background: #fff;
    border-radius: 22px;
    color: #1472ff;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
  }
  .ability-banner-wrapper .ability-banner-area a:hover {
    background: #3d91ff;
    color: #fff;
  }
  .ability-banner-wrapper .ability-banner-area a:active {
    background: #1159d6;
    color: #fff;
  }
  .ability-block-advantage .advantage-item,
  .ability-block-advantage .ct-eva-content {
    background: #fff;
    box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.04), 0 0 20px 0 rgba(0, 0, 0, 0.03);
    border-radius: 8px;
  }
  .ability-block-advantage {
    padding: 96px 0;
  }
  .ability-block-advantage .advantage-title {
    margin-bottom: 64px;
    font-size: 36px;
    font-weight: 500;
    color: #333;
    line-height: 44px;
  }
  .ability-block-advantage .advantage-list {
    display: flex;
    justify-content: space-between;
  }
  .ability-block-advantage .advantage-item {
    padding: 40px 16px;
    width: 268px;
    height: 364px;
    margin-left: 32px;
    text-align: center;
  }
  .ability-block-advantage .advantage-item:first-child {
    margin-left: 0;
  }
  .ability-block-advantage .advantage-item img {
    margin-bottom: 24px;
    width: 176px;
    height: 176px;
  }
  .ability-block-advantage .advantage-item h6 {
    margin-bottom: 8px;
    font-size: 20px;
    font-weight: 500;
    color: #333;
    line-height: 28px;
  }
  .ability-block-advantage .advantage-item p {
    font-size: 16px;
    font-weight: 400;
    color: #666;
    line-height: 24px;
  }
  .ability-block-advantage .ct-eva-title {
    margin-top: 64px;
    font-size: 28px;
    font-weight: 500;
    color: #333;
    line-height: 36px;
  }
  .ability-block-advantage .ct-eva-content {
    margin-top: 32px;
    width: 1168px;
    height: 140px;
    padding-left: 16px;
    display: flex;
  }
  .ability-block-advantage .ct-eva-content img {
    width: 140px;
    height: 140px;
  }
  .ability-block-advantage .eva-description {
    margin-left: 16px;
    display: flex;
    flex-direction: column;
    padding-top: 24px;
    color: #333;
  }
  .ability-block-advantage .eva-desc-title {
    font-size: 20px;
    font-weight: 500;
    line-height: 28px;
  }
  .ability-block-advantage .eva-desc-content {
    margin-top: 8px;
    width: 976px;
    height: 48px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }
  .ability-block-advantage,
  .flex-column-center {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .usermanage-ct-ex-bg {
    background: #fff;
  }
  .usermanage-ct-ex .ct-ex-content {
    margin-top: 64px;
  }
  .usermanage-ct-ex .content-item {
    width: 240px;
    text-align: center;
    margin-left: 160px;
  }
  .usermanage-ct-ex .content-item:first-child {
    margin-left: 0;
  }
  .usermanage-ct-ex .content-item img {
    width: 112px;
    height: 112px;
  }
  .usermanage-ct-ex .content-item .item-title {
    margin-top: 16px;
    font-size: 20px;
    font-weight: 500;
    color: #333;
    line-height: 28px;
  }
  .usermanage-ct-ex .content-item .item-content {
    margin-top: 8px;
    font-size: 16px;
    font-weight: 400;
    color: #666;
    line-height: 24px;
  }
  .usermanage-ct-loop-bg {
    background: rgba(42, 117, 237, 0.04);
  }
  .usermanage-ct-loop img {
    margin-top: 64px;
    width: 1168px;
  }
  .usermanage-ct-color img,
  .usermanage-ct-white img {
    width: 668px;
  }
  .usermanage-ct-color-bg {
    background: rgba(20, 114, 255, 0.04);
  }
  .usermanage-ct-white-bg {
    background: #fff;
  }
  .usermanage-ct-pro-bg {
    background: rgba(255, 255, 255, 0.03);
  }
  .usermanage-ct-pro .ct-pro-content {
    margin-top: 64px;
  }
  .usermanage-ct-pro .content-item {
    margin-left: 32px;
    width: 268px;
    height: 364px;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.02),
      0 20px 40px 0 rgba(0, 0, 0, 0.04);
    border-radius: 8px;
    background: #fff;
    text-align: center;
  }
  .usermanage-ct-pro .content-item:first-child {
    margin-left: 0;
  }
  .usermanage-ct-pro img {
    width: 176px;
    height: 176px;
  }
  .usermanage-ct-pro .item-title {
    margin-top: 24px;
    font-size: 20px;
    font-weight: 500;
    color: #333;
    line-height: 28px;
  }
  .usermanage-ct-pro .item-content {
    margin-top: 8px;
    width: 236px;
    font-size: 16px;
    font-weight: 400;
    color: #666;
    line-height: 24px;
  }
  .usermanage-ct-pro .ct-eva-title {
    margin-top: 64px;
    font-size: 28px;
    font-weight: 500;
    color: #333;
    line-height: 36px;
  }
  .usermanage-ct-pro .ct-eva-content {
    margin-top: 32px;
    width: 1168px;
    height: 140px;
    background: #fff;
    box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.04), 0 0 20px 0 rgba(0, 0, 0, 0.03);
    border-radius: 8px;
    padding-left: 16px;
    display: flex;
  }
  .usermanage-ct-pro .ct-eva-content img {
    width: 140px;
    height: 140px;
  }
  .usermanage-ct-pro .eva-description {
    margin-left: 16px;
    display: flex;
    flex-direction: column;
    padding-top: 24px;
    color: #333;
  }
  .usermanage-ct-pro .eva-desc-title {
    font-size: 20px;
    font-weight: 500;
    line-height: 28px;
  }
  .usermanage-ct-pro .eva-desc-content {
    margin-top: 8px;
    width: 976px;
    height: 48px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }
  .ct-title {
    font-size: 36px;
    font-weight: 500;
    color: #333;
    line-height: 44px;
  }
  .text-content {
    margin-top: 24px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }
  .flex-row-center,
  .usermanage-banner,
  .usermanage-ct-color,
  .usermanage-ct-ex .ct-ex-content,
  .usermanage-ct-pro .ct-pro-content,
  .usermanage-ct-white {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .usermanage-ct-color,
  .usermanage-ct-ex,
  .usermanage-ct-loop,
  .usermanage-ct-pro,
  .usermanage-ct-white {
    padding: 96px 0;
  }
  .flex-column-center,
  .usermanage-ct-ex,
  .usermanage-ct-ex .content-item,
  .usermanage-ct-loop,
  .usermanage-ct-pro,
  .usermanage-ct-pro .content-item {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .ability-user .usermanage-ct-color img,
  .ability-user .usermanage-ct-white img {
    width: 668px;
  }
  .text {
    display: flex;
    flex-direction: column;
    color: #333;
    width: 468px;
  }
}

.app .ability-user {
  padding-top: 1.04rem;
  .ability-banner-wrapper {
    height: 8.64rem;
    background-color: #1472ff;
    background-position: center;
    background-position-y: -0.96rem;
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.96rem 0.32rem 0;
    background-image: url('~@/assets/images/ability32_app.png');
    text-align: center;
    h1 {
      font-size: 0.8rem;
      line-height: 0.88rem;
      margin-bottom: 0px;
    }
    p {
      margin: 0.24rem auto 0;
      font-size: 0.32rem;
      font-weight: 400;
      line-height: 0.48rem;
      width: 5.6rem;
    }
    a {
      border: none;
      outline: 0;
      margin: 0.48rem auto 0;
      width: 3.2rem;
      height: 0.8rem;
      border-radius: 0.88rem;
      font-size: 0.32rem;
      font-weight: 500;
      line-height: 0.8rem;
    }
  }

  .usermanage-ct-loop,
  .usermanage-ct-ex,
  .usermanage-ct-white,
  .usermanage-ct-color {
    padding: 1.28rem 0.32rem;
  }
  .usermanage-ct-white,
  .usermanage-ct-ex,
  .usermanage-ct-color {
    display: block;
  }
  .usermanage-ct-ex {
    .ct-title {
      font-size: 0.56rem;
      line-height: 0.72rem;
      font-weight: normal;
      text-align: center;
    }
    .ct-ex-content {
      margin-top: 0.96rem;
      display: block;
      .content-item {
        position: relative;
        display: block;
        width: 100%;
        height: 2.04rem;
        padding-left: 1.92rem;
        text-align: left;
        margin-left: 0;
        & > img {
          position: absolute;
          left: 0;
          top: 0;
          width: 1.6rem;
          height: 1.6rem;
        }
        .item-title {
          margin-top: 0;
          font-size: 0.32rem;
          line-height: 0.48rem;
        }
        .item-content {
          width: auto;
          height: auto;
          margin-top: 0.16rem;
          font-size: 0.28rem;
          line-height: 0.44rem;
        }
        &:not(:first-child) {
          margin-top: 0.64rem;
        }
      }
    }
  }
  .ct-title {
    font-size: 0.56rem;
    line-height: 0.72rem;
  }
  .usermanage-ct-loop img,
  .usermanage-ct-white img,
  .usermanage-ct-color img {
    width: auto;
    max-width: 100%;
    margin-top: 0.96rem;
  }
  .text {
    width: auto;
  }
  .text-content {
    margin-top: 0.32rem;
    font-size: 0.28rem;
    font-weight: 400;
    color: #333;
    line-height: 0.44rem;
  }
  .ability-block-advantage {
    padding: 1.28rem 0.32rem;
    .advantage-title {
      font-size: 0.56rem;
      line-height: 0.72rem;
      margin-bottom: 0.96rem;
    }
    .advantage-list {
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .advantage-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0;
      width: 3.28rem;
      height: 5.56rem;
      border-radius: 0.16rem;
      margin-left: 0;
      h6 {
        height: 0.48rem;
        font-size: 0.32rem;
        font-weight: 500;
        color: #333;
        line-height: 0.48rem;
        margin-top: 0.32rem;
        margin-bottom: 0;
      }
      p {
        width: 2.32rem;
        margin-top: 0.16rem;
        font-size: 0.28rem;
        font-weight: 400;
        color: #666;
        line-height: 0.44rem;
        height: 1.32rem;
      }
      img {
        width: 2.32rem;
        height: 2.32rem;
        margin: 0;
      }
      &:nth-child(n + 3) {
        margin-top: 0.96rem;
      }
    }
  }
  .case-list {
    padding-bottom: 0;
  }
  .ct-eva-box {
    padding: 1px 0.32rem 1.12rem;
    background: #f6f9ff;

    .ct-eva-title {
      margin-top: 0.96rem;
      font-size: 0.4rem;
      line-height: 0.57rem;
      text-align: center;
    }
    .ct-eva-content {
      margin-top: 0.96rem;
      width: 6.86rem;
      background: #fff;
      padding: 0.32rem;
      font-size: 0.24rem;
      line-height: 0.48rem;
      display: flex;
      box-shadow: 0 0.2rem 0.6rem 0 rgba(102, 102, 102, 0.08);
      border-radius: 0.16rem;
      img {
        width: 1.6rem;
        height: 1.6rem;
      }
      .eva-description {
        margin-left: 0.32rem;
        display: flex;
        flex-direction: column;
        font-size: 0.24rem;
        line-height: 0.48rem;
        text-align: left;
      }
      .eva-desc-title {
        font-weight: 500;
      }
      .eva-desc-content {
        font-weight: 400;
      }
    }
  }
}
</style>
